export const quizQuestions = [
    {
      id: 1,
      question: "What is your full name?",
      type: "text",
      key: "fullName",
      required: true,
      placeholder: "Enter your full name"
    },
    {
      id: 2,
      question: "What is your age?",
      type: "number",
      key: "age",
      required: true,
      min: 13,
      max: 99,
      placeholder: "Enter your age"
    },
    {
      id: 3,
      question: "How does your skin feel an hour after cleansing (no moisturizer)?",
      type: "radio",
      key: "skinFeelAfterCleansing",
      required: true,
      options: [
        { value: "tight_dry_flaky", label: "Tight, dry, or flaky" },
        { value: "shiny_greasy", label: "Shiny or greasy" },
        { value: "comfortable_smooth", label: "Comfortable and smooth" },
        { value: "tingling_burning", label: "Tingling or burning" }
      ]
    },
    {
      id: 4,
      question: "By midday how does your T-zone (forehead, nose & chin) look?",
      type: "radio",
      key: "tZoneMidday",
      required: true,
      options: [
        { value: "always_shiny", label: "Always shiny all over" },
        { value: "slightly_oily_tzone", label: "Slightly oily in T-zone only" },
        { value: "no_shine", label: "No shine at all" },
        { value: "shiny_irritated", label: "Shiny and irritated" }
      ]
    },
    {
      id: 5,
      question: "How does your skin react to new products or weather changes?",
      type: "radio",
      key: "skinReaction",
      required: true,
      options: [
        { value: "red_itchy_irritated", label: "Red, itchy or irritated" },
        { value: "no_reaction", label: "Mostly no reaction" },
        { value: "dry_tight", label: "Feels dry or tight" },
        { value: "breakout_oily", label: "Breakout or gets oily" }
      ]
    },
    {
      id: 6,
      question: "How visible are your pores - especially on cheeks and nose?",
      type: "radio",
      key: "poreVisibility",
      required: true,
      options: [
        { value: "large_visible", label: "Large and visible" },
        { value: "visible_nose_only", label: "Visible only on nose" },
        { value: "hardly_noticeable", label: "Hardly noticeable" },
        { value: "large_red_bumps", label: "Large with redness or bumps" }
      ]
    },
    {
      id: 7,
      question: "Do you get flaking, redness or itching without using actives (like acids or retinol)?",
      type: "radio",
      key: "skinIssuesWithoutActives",
      required: true,
      options: [
        { value: "yes_often", label: "Yes, often" },
        { value: "only_winters", label: "Only in winters" },
        { value: "rarely", label: "Rarely" },
        { value: "yes_plus_burning", label: "Yes, plus burning" }
      ]
    },
    {
      id: 8,
      question: "What does your current skincare routine look like (include all skincare products that you use)?",
      type: "textarea",
      key: "currentRoutine",
      required: true,
      placeholder: "Describe your current skincare routine in detail..."
    },
    {
      id: 9,
      question: "How often do you follow your current skincare routine?",
      type: "radio",
      key: "routineFrequency",
      required: true,
      options: [
        { value: "daily_twice", label: "Daily (morning and evening)" },
        { value: "daily_once", label: "Daily (only once)" },
        { value: "few_times_week", label: "A few times a week" },
        { value: "rarely", label: "Rarely" },
        { value: "no_routine", label: "I don't follow any routine" }
      ]
    },
    {
      id: 10,
      question: "What is your email?",
      type: "email",
      key: "email",
      required: true,
      placeholder: "Enter your email address"
    },
    {
      id: 11,
      question: "What is your phone number?",
      type: "tel",
      key: "phoneNumber",
      required: true,
      placeholder: "Enter your 10-digit phone number",
      pattern: "^[6-9]\\d{9}$",
      patternMessage: "Please enter a valid 10-digit Indian phone number"
    }
  ];